<button class="ui-btn-circle {{btnStyle}} ui-btn-circle-{{size}}"
        [disabled]="disabled"
        (click)="onClick.emit()">
  <i class="icon-{{type}} ui-btn-circle-icon"></i>
</button>
